import orders from 'redux/reducers/initialState/orders';

export default {
  orders
};
